/*
 * @preserve dataset polyfill for IE < 11. See https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/dataset and http://caniuse.com/#search=dataset
 *
 * @author ShirtlessKirk copyright 2015
 * @license WTFPL (http://www.wtfpl.net/txt/copying)
 */
/*global define: false, module: false */
/*jslint nomen: true, regexp: true, unparam: true */
(function datasetModule(global, definition) { // non-exporting module magic dance
    'use strict';

    var
        amd = 'amd',
        exports = 'exports'; // keeps the method names for CommonJS / AMD from being compiled to single character variable

    if (typeof define === 'function' && define[amd]) {
        define(function definer() {
            return definition(global);
        });
    } else if (typeof module === 'function' && module[exports]) {
        module[exports] = definition(global);
    } else {
        definition(global);
    }
}(this, function datasetPolyfill(global) {
    'use strict';

    var
        attribute,
        attributes,
        counter,
        dash,
        dataRegEx,
        document = global.document,
        hasEventListener,
        length,
        match,
        mutationSupport,
        test = document.createElement('_'),
        DOMAttrModified = 'DOMAttrModified';

    function clearDataset(event) {
        delete event.target._datasetCache;
    }

    function toCamelCase(string) {
        return string.replace(dash, function (m, letter) {
            return letter.toUpperCase();
        });
    }

    function getDataset() {
        var
            dataset = {};

        attributes = this.attributes;
        for (counter = 0, length = attributes.length; counter < length; counter += 1) {
            attribute = attributes[counter];
            match = attribute.name.match(dataRegEx);
            if (match) {
                dataset[toCamelCase(match[1])] = attribute.value;
            }
        }

        return dataset;
    }

    function mutation() {
        if (hasEventListener) {
            test.removeEventListener(DOMAttrModified, mutation, false);
        } else {
            test.detachEvent('on' + DOMAttrModified, mutation);
        }

        mutationSupport = true;
    }

    if (test.dataset !== undefined) {
        return;
    }

    dash = /\-([a-z])/ig;
    dataRegEx = /^data\-(.+)/;
    hasEventListener = !!document.addEventListener;
    mutationSupport = false;

    if (hasEventListener) {
        test.addEventListener(DOMAttrModified, mutation, false);
    } else {
        test.attachEvent('on' + DOMAttrModified, mutation);
    }

    // trigger event (if supported)
    test.setAttribute('foo', 'bar');

    Object.defineProperty(global.Element.prototype, 'dataset', {
        get: mutationSupport
            ? function get() {
                if (!this._datasetCache) {
                    this._datasetCache = getDataset.call(this);
                }

                return this._datasetCache;
            } : getDataset
    });

    if (mutationSupport && hasEventListener) { // < IE9 supports neither
        document.addEventListener(DOMAttrModified, clearDataset, false);
    }
}));

(function() {
    var API_ROOT = 'https://pristine.eastsideco.io/api/v1';

    var DownloadsComponent = {
        data: function() {
            return {
                albums: [],
                page: 1,
                lastPage: 1,
                limit: 50,
                showingFrom: null,
                showingTo: null,
                totalAlbums: 0,
              	isLoading: false,
            };
        },
        mounted: function() {
          this.loadData();
        },
        methods: {
          sortDownloadables: function (downloadables) {
            return downloadables.slice().reverse();
          },
          nextPage: function() {
            this.page++;
            this.scrollTop();
            this.loadData();
          },
          previousPage: function() {
            this.page--;
            this.scrollTop();
            this.loadData();
          },
          scrollTop: function() {
            window.scrollTo(0, 0);
          },
          loadData: function() {
            this.isLoading = true;
            var that = this;
            superagent.post(API_ROOT+'/account/')
                .send({
                  shop: this.$root.$data.shopDomain,
                  customerId: this.$root.$data.customerId,
              	  page: this.page,
                })
                .end(function(err, res) {
                  if (err || !res.ok) {
                    console.log(err);
                  } else {
                    that.isLoading = false;
                    that.albums = res.body.account.albums;
                    that.lastPage = res.body.account.last_page;
                    that.totalAlbums = res.body.account.total_albums;
                    that.showingFrom = res.body.account.showing_from;
                    that.showingTo = res.body.account.showing_to;
                  }
                });
          }
        }
    };


    function AccountArea(el, customerId, shopDomain) {
        return new Vue({
            el: el,
            data: {
                shopDomain : shopDomain,
                customerId: customerId,
            },
            components: {
                downloads: DownloadsComponent,
            },
        });
    };


    document.addEventListener('DOMContentLoaded', function() {
        var el = document.querySelector('[data-app="pristine-account-area"]');
        if (!el) { return; }

        var customerId = el.dataset.customer;
        var shopDomain = el.dataset.shop;
      
        window.PristineAccountArea = new AccountArea(el, customerId, shopDomain);
    });
})();
